import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from '../admin-console-activity-reporting/config-item.gql';
import { GetConfigItem } from '../admin-console-activity-reporting/__generated__/GetConfigItem';

const CONFIG_KEY = 'enterprise-sub-lock-structures';

export function EnterpriseSubLockStructures() {
  const [queryConfigItem] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [enabled, setEnabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryConfigItem({ variables: { key: CONFIG_KEY } }).then((response) =>
      setEnabled(
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue ?? false
      )
    );
  }, []);

  const saveConfigItem = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    saveConfigItem
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: CONFIG_KEY,
          value: !enabled,
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Request failed');
        }
        setEnabled(!enabled);
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      })
      .catch(() => {
        setSnackbar({
          open: true,
          message: 'Unable to update setting',
          variant: 'error',
        });
      });
  };

  return (
    <Box display='flex' alignItems={'center'}>
      <Switch
        checked={Boolean(enabled)}
        disabled={enabled === undefined || saveConfigItem.isLoading}
        onChange={onSave}
        color='primary'
        inputProps={{ 'aria-label': 'lock core structures in sub-accounts' }}
      />
      <Box ml={1}>
        <Typography
          style={{
            fontWeight: 500,
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Lock core structures in sub-accounts
        </Typography>
        <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
          {
            'Sub-accounts can view but not create, edit or delete programs, roles, tasks, report types, forms, matching rules, screening questions, resources and email content. Activities, rosters, volunteers and day-to-day work are unaffected, as is this account.'
          }
        </Typography>
      </Box>
    </Box>
  );
}
